import React, { useState, useCallback, memo } from 'react';
import { Flex, Drawer, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { ProductCard } from '@ozoneuniverse/ui-components/build-pkg/src/components/asset-store/products/ProductCard';
import { useFindManyGeneratedAssetsQuery } from '@src/components/generated/graphql';
import ModelViewerModal from '../web2-asset-store/ModelViewer';
import { SIDE_MENU_EVENTS } from '@src/components/menu/sideMenu';

const Cards = ({ loading, assets, onOpenPreview, onLoadAsset }) => {
  return (
    <Flex gap={20} wrap='wrap'>
      {loading ? (
        <Spin
          indicator={
            <LoadingOutlined style={{ fontSize: 30, color: '#000' }} spin />
          }
        />
      ) : (
        <>
          {assets?.length ? (
            assets?.map((el, i) => {
              return (
                <ProductCard
                  disableLink={true}
                  disableButtons={true}
                  type='web2'
                  customButton={{
                    text: 'Add to the scene',
                    onClick: () => onLoadAsset(el.assetUrl, `${i}-${el.name}`),
                  }}
                  key={`${i}-${el.name}`}
                  product={{
                    assetURL: el.assetUrl,
                    previewImage: el.previewUrl,
                    ...el,
                  }}
                  imgOnClick={() => onOpenPreview(el.assetUrl)}
                />
              );
            })
          ) : (
            <>Sorry, no found assets</>
          )}
        </>
      )}
    </Flex>
  );
};

const CardsMemo = memo(Cards);

export default function GeneratedAssetsInventory({
  isOpen,
  setIsOpen,
  addToScene,
  userId,
}) {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [modelUrl, setModelUrl] = useState('');

  const { data, loading } = useFindManyGeneratedAssetsQuery({
    variables: {
      where: {
        userId: {
          equals: userId,
        },
      },
    },
    fetchPolicy: 'no-cache',
  });

  const assets = data?.findManyGeneratedAssets;

  const onOpenPreview = useCallback((url) => {
    setPreviewOpen(true);
    setModelUrl(url);
  }, []);

  const onLoadAsset = useCallback((url, name) => {
    addToScene({
      name: name,
      url: url,
      type: SIDE_MENU_EVENTS.LIBRARY_3D,
      index: 0,
    });
    setIsOpen(false);
  }, []);

  return (
    <>
      <Drawer
        open={isOpen}
        onClose={() => setIsOpen(false)}
        closeIcon={false}
        footer={false}
        zIndex={1001}
        width={'90%'}
        title={
          <>
            <h3 style={{ marginBottom: 20 }}>Your Ozone AI Generated Assets</h3>
          </>
        }
      >
        <CardsMemo
          loading={loading}
          onOpenPreview={onOpenPreview}
          assets={assets}
          onLoadAsset={onLoadAsset}
        />
        <ModelViewerModal
          open={previewOpen}
          setOpen={setPreviewOpen}
          modelUrl={modelUrl}
        />
      </Drawer>
    </>
  );
}
